import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from '../components/Reveal';
import SectionHeading from '../components/SectionHeading';

const { FiSun, FiTruck, FiCoffee } = FiIcons;
const moments = [
  { day: 'Freitag', title: 'Das große Open Air (Stadtpark)', text: 'Der bunte, qualitative Kickoff in das Schlager-Wochenende. Ein Boutique-Festival unter freiem Himmel, das musikalisch einheizt, aber genug Raum für gute Gastro und entspanntes Feiern lässt.', icon: FiSun, tag: 'DER AUFTAKT' },
  { day: 'Samstag', title: 'Die Sichtbarkeit (Schlagermove & Sonnendeck)', text: 'Wir entern den Move! Mit einem eigenen "Herzschlag Hamburg"-Truck im charakteristischen Wellenmuster sorgen wir für maximale Sichtbarkeit. Parallel bietet das Sonnendeck St. Pauli unsere gebrandete Chill-Out-Oase.', icon: FiTruck, tag: 'DIE STADT IN BEWEGUNG' },
  { day: 'Sonntag', title: 'Der Community-Brunch', text: 'Im Sonnendeck St. Pauli kurieren wir bei Mimosas und entspannter Musik den Kater vom Wochenende und machen die Gäste zu echten Fans der Marke.', icon: FiCoffee, tag: 'DAS WIEDERSEHEN' }
];

function JourneySection() {
  return (
    <section className="section journey-section" id="wochenende">
      <div className="section-inner">
        <SectionHeading eyebrow="05 — Eine Marke zum Erleben">Das Touchpoint-Konzept</SectionHeading>
        <div className="journey-intro">
          <p>Drei Tage. Eine Stadt. Ein Herzschlag.</p>
          <span>HAMBURG · FESTIVAL-WOCHENENDE 2027</span>
        </div>
        <div className="journey-grid">
          {moments.map(({ day, title, text, icon, tag }, index) => (
            <Reveal className="journey-card" delay={index * 0.1} key={day}>
              <div className="journey-card-top"><span className="journey-icon"><SafeIcon icon={icon} /></span><span className="journey-tag">{tag}</span></div>
              <span className="journey-day">{day}</span>
              <h3>{title}</h3>
              <p>{text}</p>
              <span className="journey-count">0{index + 1}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default JourneySection;